import { FC, ReactElement } from 'react'

import { SvgIconProps } from '@/components/Icon/Icon'

export const IconRepeat: FC<SvgIconProps> = ({ className = '' }): ReactElement => (
    <svg
        aria-hidden="true"
        className={`icon-component ${className}`}
        viewBox="0 0 24 24"
        fill="none"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path className="stroke" d="m17 2 4 4-4 4" />
        <path className="stroke" d="M3 11v-1a4 4 0 0 1 4-4h14" />
        <path className="stroke" d="m7 22-4-4 4-4" />
        <path className="stroke" d="M21 13v1a4 4 0 0 1-4 4H3" />
    </svg>
)
